<template>
  <div class="is-flex is-justify-content-center py-6 px-4">
    <div class="container">

      <div class="py-2">
        <div class="is-flex is-justify-content-center" v-if="getLogoEmail">
          <figure class="image is-128x128">
            <img :src="getLogoEmail" alt="Logo" />
          </figure>
        </div>
        <p class="has-text-info is-size-5 has-text-weight-semibold has-text-centered mt-4">
          This tour will go live on {{ publishDate }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { formatInTimeZone, toDate } from 'date-fns-tz';

  export default {
    computed: {
      ...mapGetters(
        'tour', [
          'getAccess',
          'getLogoEmail'
        ]
      ),
      publishDate () {
        const date = toDate(this.getAccess.publishDate, { timeZone: this.getAccess.timeZone });
        return formatInTimeZone(date, this.getAccess.timeZone, 'MMMM d, yyyy, h:mm a zzzz')
          .replace('Alaska Standard Time', 'AKST')
          .replace('Alaska Daylight Time', 'AKDT')
          .replace('Atlantic Time', 'AT')
          .replace('Atlantic Standard Time', 'AST')
          .replace('Atlantic Daylight Time', 'ADT')
          .replace('Central Time', 'CT')
          .replace('Central Standard Time', 'CST')
          .replace('Central Daylight Time', 'CDT')
          .replace('Eastern Time', 'ET')
          .replace('Eastern Standard Time', 'EST')
          .replace('Eastern Daylight Time', 'EDT')
          .replace('Pacific Standard Time', 'PST')
          .replace('Pacific Daylight Time', 'PDT')
          .replace('Pacific Time', 'PT');
      }
    },
  };
</script>

<style lang="scss">
  @charset "utf-8";

  @import url("https://fonts.googleapis.com/css?family=Fira+Sans:400,700&subset=latin-ext");

  @import "../assets/styles/mixins";

  $family-sans-serif: 'Fira Sans', sans-serif;

  @import "~bulma/sass/utilities/_all.sass";
  @import "~bulma/sass/base/_all.sass";
  @import "~bulma/sass/elements/_all.sass";
  @import "~bulma/sass/form/_all.sass";
  @import "~bulma/sass/helpers/_all.sass";
</style>
